import { Component } from '@angular/core';

// Shown to authenticated users who belong to none of the access groups.
@Component({
    selector: 'app-no-access',
    standalone: true,
    template: `
        <div class="no-access">
            <h2>No Access</h2>
            <p>{{ message }}</p>
        </div>
    `
})
export class NoAccessComponent {
    protected readonly message =
        "Your account doesn't have permission to view this application. Please contact your administrator if you believe this is a mistake.";
}
